import React from 'react';
import { useTranslation } from 'react-i18next';
import RoasterSelect from '../../organisms/RoasterSelect';
import PageLayout from '../../atoms/PageLayout';
import RoasterWarehouseItems from './RoasterWarehouseItems';
var AdminNewDeliveryRequestPage = function () {
    var t = useTranslation().t;
    var _a = React.useState(), roaster = _a[0], setRoaster = _a[1];
    var handleChangeRoaster = React.useCallback(function (roaster) {
        if (!roaster)
            setRoaster(undefined);
        setRoaster(roaster);
    }, []);
    return (React.createElement(PageLayout, { title: t('pages.newDeliveryRequest.title') },
        React.createElement(RoasterSelect, { value: roaster, onChange: handleChangeRoaster }),
        roaster && React.createElement(RoasterWarehouseItems, { roasterId: roaster.id })));
};
export default AdminNewDeliveryRequestPage;
